/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskCustomRulesList } from "../funcs/riskCustomRulesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListCustomDetectionRulesResult } from "../models/components/listcustomdetectionrulesresult.js";
import {
  ListCustomDetectionRulesRequest,
  ListCustomDetectionRulesSecurity,
} from "../models/operations/listcustomdetectionrules.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListCustomDetectionRulesQueryData =
  ListCustomDetectionRulesResult;

export function prefetchRiskListCustomDetectionRules(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListCustomDetectionRulesRequest | undefined,
  security?: ListCustomDetectionRulesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListCustomDetectionRulesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListCustomDetectionRulesQuery(
  client$: GramCore,
  request?: ListCustomDetectionRulesRequest | undefined,
  security?: ListCustomDetectionRulesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListCustomDetectionRulesQueryData>;
} {
  return {
    queryKey: queryKeyRiskListCustomDetectionRules({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListCustomDetectionRulesQueryFn(
      ctx,
    ): Promise<RiskListCustomDetectionRulesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskCustomRulesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListCustomDetectionRules(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "customRules", "list", parameters];
}
